import { License } from '@yfiles/yfiles';
import { environment } from '../environments/environment';

export const loadLicense = () => {
    License.value = environment.production?
        {
        "company": "LINQ Ltd.",
        "date": "08/13/2025",
        "distribution": true,
        "domains": [
            "linq.it",
            "my.thinklikelinq.com",
            "my.thinklikelinq.com",
            "linq.it"
        ],
        "fileSystemAllowed": false,
        "licensefileversion": "1.1",
        "localhost": false,
        "oobAllowed": false,
        "package": "complete",
        "product": "yFiles for HTML",
        "projectname": "LINQ Development",
        "subscription": "08/12/2026",
        "type": "project",
        "version": "3.0",
        "key": "5a412f97d6fb6c13a724b8d07158e9c70e2e2598"
    }:{
        "company": "LINQ Ltd.",
        "date": "08/13/2025",
        "distribution": false,
        "domains": [
            "*"
        ],
        "fileSystemAllowed": true,
        "licensefileversion": "1.1",
        "localhost": true,
        "oobAllowed": true,
        "package": "complete",
        "product": "yFiles for HTML",
        "projectname": "LINQ Development",
        "subscription": "08/12/2026",
        "type": "project",
        "version": "3.0",
        "watermark": "yFiles HTML Development License",
        "key": "8c8d8b5644ad6593eb2082fb09cc21e98bd5fbe8"
    }        
}

